/**
 * SCIFI_ARCHETYPE
 *
 * Statistical profile for Sci-Fi, Cyber-Orch, and Futuristic genres.
 * Focuses on synthetic textures, angular melodies, and atmospheric tension.
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const SCIFI_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Static or slowly evolving (Drone-like)
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 4.0, // 1 Chord per 4 bars (Slow)
        tolerance: 2.0
    },

    // Harmonic Consonance: Dissonance is welcome (Augmented, Suspended)
    harmonicConsonance: {
        ...SLOW_ARCHETYPE.harmonicConsonance,
        polarity: 'dissonant', // Favor tension
        weight: 0.2
    },

    // Voice Distribution: "Hollow" (Low Bass + High Texture, scooped Mids)
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.40,
        mid: 0.15,
        high: 0.45,
        tolerance: 0.2,
        tuttiThreshold: 0.9,
        weight: 0.25
    },

    // Dynamic Range: Cold, consistent, or sudden swells.
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.05, // Can be flatter (robotic)
        targetVariance: 0.15,
        dynamicShape: 'linear',
        weight: 0.15
    },

    // Interval Entropy: Angular, wide leaps, or arpeggiated.
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.4, // Less stepwise, more leaps/arps
        weight: 0.2
    },

    // Rhythmic Lock: Mechanical precision.
    rhythmicLock: {
        ...SLOW_ARCHETYPE.rhythmicLock,
        weight: 0.3
    },

    // Narrative Arc: Slow evolution.
    narrativeArc: {
        weight: 0.1
    }
};
